import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Flex,
  PopoverAnchor,
  InputRightAddon,
  Button,
  Grid
} from '@chakra-ui/react'
import React from 'react'
import { FaList } from 'react-icons/fa'

const responsabilidades = [
  "TKE",
  "O Síndico",
  "O Condomínio"
]
export function PopoverResponsabilidade({ setResponsabilidade }: any) {
  const initRef = React.useRef<any>()
  return (
    <Popover

      initialFocusRef={initRef}
    >
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger >
            <InputRightAddon children={<FaList />} />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader>Responsabilidade</PopoverHeader>
            <PopoverBody>
              <Grid gap={4} maxH="40vh" overflowY={"scroll"}>
                {responsabilidades?.map((item, i) => (
                  <Button
                    key={`responsabilidade-button-form-${i}`}
                    ref={initRef}
                    onClick={() => {
                      setResponsabilidade(item);
                      onClose();
                    }}>
                    {item}
                  </Button>
                ))}
               
              </Grid>
            </PopoverBody>
          </PopoverContent>
        </>
      )}

    </Popover>

  )
}